import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Fund, FundApiService} from "../generated-sources/api";
import {GeneralPartner} from "../models/general-partner";
import {GeneralPartnerPage} from "../models/general-partner-page";
import {GeneralPartnerOverviewParams} from "../store/fund.state";

@Injectable({
    providedIn: "root"
})
export class GeneralPartnerService {
    private readonly fundApiService = inject(FundApiService);

    constructor( ) {
    }

    getGeneralPartners(isArchived?: boolean): Observable<GeneralPartner[]> {
        return this.fundApiService.getGeneralPartners(isArchived);
    }

    getGeneralPartner(id: number): Observable<GeneralPartner> {
        return this.fundApiService.getGeneralPartner(id);
    }

    saveGeneralPartner(generalPartner: GeneralPartner): Observable<GeneralPartner> {
        return generalPartner.id
            ? this.fundApiService.updateGeneralPartner(generalPartner.id, generalPartner)
            : this.fundApiService.createGeneralPartner(generalPartner);
    }

    archiveGeneralPartner(partnerId: number, archive: boolean): Observable<GeneralPartner> {
        return this.fundApiService.patchGeneralPartner(partnerId, { archive });
    }

    createGeneralPartnerAndAssignToFund(generalPartner: GeneralPartner, fundId: number): Observable<Fund> {
        return this.fundApiService.createGeneralPartnerAndAssignToFund({
            fundId,
            generalPartner
        });
    }

    assignGeneralPartnerToFund(partnerId: number, fundId: number): Observable<Fund> {
        return this.fundApiService.assignGeneralPartnerToFund(partnerId, fundId);
    }

    getFundsForGeneralPartner(partnerId: number): Observable<Fund[]> {
        return this.fundApiService.getFundsForGeneralPartner(partnerId);
    }

    searchGeneralPartners(params: GeneralPartnerOverviewParams): Observable<GeneralPartnerPage> {
        return this.fundApiService.searchGeneralPartners(
            params.search || undefined,
            params.page,
            params.size,
            params.sort,
            params.isArchived
        );
    }
}
